// extracted by mini-css-extract-plugin
export default {"bgWrap":"TermsAndConditionsOfServicePage_bgWrap__Qlyak","heroSection":"TermsAndConditionsOfServicePage_heroSection__Ole71"};